import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { CloudFile } from 'owa-attachment-file-types';
import { ControlIcons } from 'owa-control-icons';
import { lazyOperateContent } from 'owa-editor';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { LinkIdContainer } from 'owa-attachment-link-common';
import { RecipientContainer } from 'owa-link-data';
import loc from 'owa-localize';
import * as React from 'react';
import { closeLinkPlaceholderContextMenu } from '../components/LinkPlaceholderContextMenu';
import { insertLinkIntoComposeEditor } from '../insertLinksFromFilePicker/insertLinksIntoComposeEditor';
import { getInsertLinkFailureInfo } from '../utils/getInsertLinkFailureInfo';
import { RemoveLinkButtonText, RetryButtonText } from '../utils/insertLink.locstring.json';
import { onStartRetrievingSharingLink } from '../actions/internalActions';

const { useCallback } = React;

export interface LinkPlaceholderContextMenuItemProps {
    linkId: string;
    file: CloudFile;
    editorViewState: EditorViewState;
    getRecipientWells: () => RecipientContainer[];
    linkIdContainer: LinkIdContainer;
    fromAddress: string;
    targetWindow: Window;
}

const styles = require('./LinkPlaceholderContextMenuItem.scss');

async function retryToInsertLink(contextMenuItemProps: LinkPlaceholderContextMenuItemProps) {
    closeLinkPlaceholderContextMenu();
    onStartRetrievingSharingLink(contextMenuItemProps.linkId);
    insertLinkIntoComposeEditor(
        contextMenuItemProps.editorViewState,
        contextMenuItemProps.getRecipientWells,
        contextMenuItemProps.fromAddress,
        contextMenuItemProps.linkIdContainer,
        contextMenuItemProps.file,
        contextMenuItemProps.linkId,
        true /* viaContextMenuItem */,
        contextMenuItemProps.targetWindow
    );
}

async function removeLink(viewState: EditorViewState, nodeId: string) {
    closeLinkPlaceholderContextMenu();
    const operateContent = await lazyOperateContent.import();
    operateContent(viewState, (editor, range, domUtils) => {
        const removeTargets: HTMLElement[] = editor.queryElements('#' + nodeId);
        editor.deleteNode(removeTargets[0]);
        return {
            selectionRange: null,
            changeSource: null,
        };
    });
}

export const LinkPlaceholderContextMenuItem = (
    contextMenuItemProps: LinkPlaceholderContextMenuItemProps
) => {
    const failureInfo = getInsertLinkFailureInfo(contextMenuItemProps.file);

    const retryButtonClickHandler = useCallback(() => {
        retryToInsertLink(contextMenuItemProps);
    }, [contextMenuItemProps]);

    const removeLinkButtonClickHandler = useCallback(() => {
        removeLink(contextMenuItemProps.editorViewState, contextMenuItemProps.linkId);
    }, [contextMenuItemProps.editorViewState, contextMenuItemProps.linkId]);

    return (
        <div>
            <div
                className={styles.menuItemContainer}
                aria-posinset={1}
                aria-setsize={7}
                aria-disabled="false"
                role="menuitem">
                <span className={styles.iconContainer}>
                    <Icon iconName={ControlIcons.Warning} className={styles.icon} />
                </span>
                {failureInfo}
            </div>
            <div className={styles.buttonItemContainer}>
                <span>
                    <button onClick={retryButtonClickHandler}>{loc(RetryButtonText)}</button>
                </span>
                <span>
                    <button onClick={removeLinkButtonClickHandler}>
                        {loc(RemoveLinkButtonText)}
                    </button>
                </span>
            </div>
        </div>
    );
};
